import React, { ReactElement, useState } from 'react';

import CustomIcon, { SeturIcon } from '@components/utils/CustomIcon/index';
import { useDevice } from '@contexts/device';
import Typography from '@components/Typography';

import { StyledTab, StyledTabs, TabText } from './styled';

export interface ITabItemProps {
  title: string;
  icon: SeturIcon;
  disabled?: boolean;
  type?: string;
  feature?: string;
}
export type TabProps = {
  onTabSelection: (selection: number) => void;
  selected: number;
  children: React.ReactNode[];
};

type TabItemProps = {
  onClick?: () => void;
  isSelected?: boolean;
  text: string;
  icon: SeturIcon;
  disabled?: boolean;
  children?: React.ReactNode;
};
export const TabItem = ({
  isSelected,
  text,
  icon,
  onClick,
  disabled,
}: TabItemProps) => {
  const [hover, setHover] = useState(false);
  const { isDesktop } = useDevice();
  return (
    <StyledTab
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      selected={isSelected}
      hover={hover}
      onClick={onClick}
      disabled={disabled}
    >
      {isSelected || hover ? (
        <CustomIcon
          paletteColor='BR500'
          fontSize={isDesktop ? 24 : 18}
          width={isDesktop ? 24 : 18}
          height={isDesktop ? 24 : 18}
          icon={icon}
        />
      ) : null}
      <TabText>
        <Typography
          variant='caption1'
          color='BR500'
          weight={isSelected ? 'Bold' : 'Regular'}
        >
          {text}
        </Typography>
      </TabText>
    </StyledTab>
  );
};

const Tab = ({
  onTabSelection,
  children,
  selected,
}: React.PropsWithChildren<TabProps>) => (
  <StyledTabs>
    {React.Children.map(children, (child, index) =>
      React.cloneElement(child as ReactElement, {
        onClick: () => onTabSelection && onTabSelection(index),
        isSelected: selected === index,
        key: index,
      })
    )}
  </StyledTabs>
);

export default Tab;
